import { Button, Grid, Modal, Typography } from "@mui/material";
import React from "react";
import styles from "./ModalConfirmDelete.module.scss";

const ModalConfirmDelete = (props: any) => {
  const { onClose, onSubmit, title= "Xác Nhận Xóa Bài Viết" } = props;
  return (
    <Modal open={true} onClose={onClose} className={styles.ModalDelete}>
      <Grid className={styles.ModalDeleteMain}>
        <Typography className={styles.TitleConfirm}>
          {title}
        </Typography>

        <Grid
          container
          justifyContent={"space-between"}
          className={styles.GroupButtonConfirm}
        >
          <Button className={styles.ButtonCancel} onClick={onClose} color="secondary">
            Hủy
          </Button>
          <Button
            variant="contained"
            className={styles.ButtonSubmit}
            onClick={onSubmit}
            style={{background:"#41B60B"}}
          >
            Xác Nhận
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ModalConfirmDelete;
